import { useEffect } from 'react'
import * as React from 'react'
import { OfficeInstance } from '../../../../models/Office'
import { NextButton } from '../../../../shared/components/Button'
import { SimpleLink, Text } from '../../../../shared/components/Elements'
import { HeadlineCSS } from '../../../../shared/components/Headlines'
import { breakpoint, styled } from '../../../../shared/styled-components'
import { Utils } from '../../../../shared/Utils'
import * as ReactGA from 'react-ga'

interface IProps {
  office: OfficeInstance
  trackingSource?: string
}

export const OfficeItem = ({ office, trackingSource }: IProps) => {
  useEffect(() => {
    ReactGA.event({
      category: 'Offices',
      action: 'Display in ' + trackingSource,
      label: `${office.name} (ID ${office.id})`,
      nonInteraction: true
    })
  }, [])

  const imageStyle = {
    backgroundImage: `url('${Utils.getAssetPath(office.image.url)}')`
  }
  return (<Container className={office.supportsAllOn4 ? 'js-supportsAllOn4' : null}>
    <Image as={office.landingpage ? 'a' : null} style={imageStyle} href={office.landingpage} target="_blank" />
    <Information>
      {office.landingpage
        ? <NameLink href={office.landingpage} target="_blank"><Name>{office.name}</Name></a>
        : <Name>{office.name}</Name>
      }

      {office.description && <Description>{office.getTruncatedDescription(200)}</Description>}

      {office.landingpage && <LandingpageButton href={office.landingpage} target='_blank'>Mehr über {office.name}</LandingpageButton>}
    </Information>
    {/*<JamedaBadge>*/}
    {/*  <JamedaImage src={Utils.getAssetPath('/assets/calculator/result/jameda.png')} />*/}
    {/*</JamedaBadge>*/}
    <ContactInformation>
      <ContactInformationRow icon='/assets/icons/location.svg'>{office.address}</ContactInformationRow>
      <ContactInformationRow icon='/assets/icons/web.svg'>
        <ContactInformationLink href={office.website} target='_blank'>{office.website}</ContactInformationLink>
      </ContactInformationRow>
      <ContactInformationRow icon='/assets/icons/phone.svg'>
        <ContactInformationLink href={`tel:${office.phone}`}>{office.phone}</ContactInformationLink>
      </ContactInformationRow>
      {office.distance !== null && <ContactInformationRow bold icon='/assets/icons/distance.svg'>Entfernung der Praxis: {office.distance.toFixed(1)} km</ContactInformationRow>}
      {office.drFlexId && <DrFlexButton as='button' small primary fullWidth onClick={() => (window as any).toggleDrFlexAppointments?.(office.drFlexId)}>Jetzt online Termin vereinbaren</DrFlexButton>}
    </ContactInformation>
  </Container>)
}

const Container = styled.li`
  background: white;
  border-radius: 3px;
  padding: 20px;
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  ${breakpoint('tablet')`
    flex-direction: row;
    flex: 0 0 260px;
  `}
`

const Image = styled.div`
  background: center center no-repeat;
  background-size: cover;
  flex: 0 0 200px;
  margin-bottom: 20px;
  border-radius: 10px;
  ${breakpoint('tablet')`
    flex: 0 0 290px;
    margin-right: 25px;
    margin-bottom: 0px;
  `}
`

const Information = styled.div`
  flex: auto;
`
const Name = styled.h3`
  ${HeadlineCSS};
  font-size: 24px !important;
  color: ${props => props.theme.primaryColor};
  margin-bottom: 1em;
`
const Description = styled(Text)`
  font-size: 16px;
  font-style: italic;
  line-height: 1.5;
  ${breakpoint('tablet')`
    margin-bottom: 0px;
    margin-right: 45px;
  `}
`
const JamedaBadge = styled.div`
  flex: 0 0 200px;
`
const JamedaImage = styled.img`
  margin-top: -20px;
`
const ContactInformation = styled.div`
  flex: 0;
  ${breakpoint('tablet')`
    flex: 0 0 370px;
  `}
`
const ContactInformationRow = styled.div<{ bold?: boolean, icon?: string }>`
  background: url('${props => props.icon}') no-repeat left center;
  background-size: 18px 18px;
  padding-left: 35px;
  line-height: 35px;
  font-size: 16px;
  ${props => props.bold && `
    color: ${props.theme.headlineColor};
    font-weight: 500;
  `};
`

const ContactInformationLink = styled(SimpleLink)`
  color: ${props => props.theme.textColor};
`

const DrFlexButton = styled(NextButton)`
  margin-top: 20px;
`

const LandingpageButton = styled.a`
  display: inline-block;
  background: ${props => props.theme.inputBackgroundColor} url(${Utils.getAssetPath('/assets/icons/arrow-right-grey.svg')}) no-repeat 90% center;
  text-decoration: none;
  font-weight: bold;
  margin-top: 20px;
  color: ${props => props.theme.textColor};
  line-height: 35px;
  padding: 0 50px 0 20px;
  font-size: 14px;
  border-radius: 3px;
`

const NameLink = styled.a`
  text-decoration: none;
`
